import { AppVersionVo } from './app-version-vo';
import { DateVo } from './date-vo';
import { SingleTemplateModel } from './single-template-model';
import { SuitablePhotosCountVo } from './suitable-photos-count-vo';
import { TemplateModel } from './template-model';
import { TemplatePageVo } from './template-page-vo';
import { TemplateSizeCateoryEnum } from './template-size-category-enum';

export class MultiTemplateModel extends TemplateModel {
  constructor(
    id: number,
    author: string,
    uploaderInfo: string,
    sourceUrl: string,
    isVip: boolean,
    isAnimated: boolean,
    thumbnailUrl: string,
    animatedThumbnailUrl: string,
    sizeCategory: TemplateSizeCateoryEnum,
    slotsCount: number,
    creatorId: string | null,
    createdAt: DateVo,
    updatedAt: DateVo,
    isMultipage: boolean,
    isAdjustable: boolean,
    suitablePhotosCount: SuitablePhotosCountVo,
    labels: string[],
    minimalRequiredVersionIos: AppVersionVo | null,
    minimalRequiredVersionAndroid: AppVersionVo | null,
    templateTagIds: number[],
    shouldRemoveAnimatedThumbnail: boolean,
    thumbnailBinary: Uint8Array | null,
    animatedThumbnailBinary: Uint8Array | null,
    newTemplateTagNames: string[],
    suitsVideo: boolean,
    private pagesInfo: TemplatePageVo[],
    private templatePageIds: number[],
  ) {
    super(
      id,
      author,
      uploaderInfo,
      sourceUrl,
      isVip,
      isAnimated,
      thumbnailUrl,
      animatedThumbnailUrl,
      sizeCategory,
      slotsCount,
      creatorId,
      createdAt,
      updatedAt,
      isMultipage,
      isAdjustable,
      suitablePhotosCount,
      labels,
      minimalRequiredVersionIos,
      minimalRequiredVersionAndroid,
      templateTagIds,
      shouldRemoveAnimatedThumbnail,
      thumbnailBinary,
      animatedThumbnailBinary,
      newTemplateTagNames,
      suitsVideo,
    );
  }

  public static create(
    id: number,
    author: string,
    uploaderInfo: string,
    sourceUrl: string,
    isVip: boolean,
    isAnimated: boolean,
    imageUrl: string,
    animatedImageUrl: string,
    sizeCategory: TemplateSizeCateoryEnum,
    slotsCount: number,
    creatorId: string | null,
    createdAt: DateVo,
    updatedAt: DateVo,
    isMultipage: boolean,
    isAdjustable: boolean,
    suitablePhotosCount: SuitablePhotosCountVo,
    labels: string[],
    minimalRequiredVersionIos: AppVersionVo | null,
    minimalRequiredVersionAndroid: AppVersionVo | null,
    templateTagIds: number[],
    shouldRemoveAnimatedThumbnail: boolean,
    thumbnailBinary: Uint8Array | null,
    animatedThumbnailBinary: Uint8Array | null,
    newTemplateTagNames: string[],
    suitsVideo: boolean,
    pagesInfo: TemplatePageVo[],
    templatePageIds: number[],
  ): MultiTemplateModel {
    return new MultiTemplateModel(
      id,
      author,
      uploaderInfo,
      sourceUrl,
      isVip,
      isAnimated,
      imageUrl,
      animatedImageUrl,
      sizeCategory,
      slotsCount,
      creatorId,
      createdAt,
      updatedAt,
      isMultipage,
      isAdjustable,
      suitablePhotosCount,
      labels,
      minimalRequiredVersionIos,
      minimalRequiredVersionAndroid,
      templateTagIds,
      shouldRemoveAnimatedThumbnail,
      thumbnailBinary,
      animatedThumbnailBinary,
      newTemplateTagNames,
      suitsVideo,
      pagesInfo,
      templatePageIds,
    );
  }

  public static createMock(): MultiTemplateModel {
    return new MultiTemplateModel(
      0,
      '',
      '',
      '',
      false,
      false,
      '',
      '',
      TemplateSizeCateoryEnum.Square,
      0,
      null,
      DateVo.create(new Date()),
      DateVo.create(new Date()),
      false,
      false,
      SuitablePhotosCountVo.create(0, 0),
      [],
      null,
      null,
      [],
      false,
      null,
      null,
      [],
      false,
      [],
      [],
    );
  }

  public getPagesInfo(): TemplatePageVo[] {
    return this.pagesInfo;
  }

  public getTemplatePageIds(): number[] {
    return this.templatePageIds;
  }

  public updateTemplatePageIds(templatePageIds: number[]) {
    this.templatePageIds = templatePageIds;
  }

  public clone() {
    return new MultiTemplateModel(
      this.getId(),
      this.getAuthor(),
      this.getUploaderInfo(),
      this.getSourceUrl(),
      this.getIsVip(),
      this.getIsAnimated(),
      this.getThumbnailUrl(),
      this.getAnimatedThumbnailUrl(),
      this.getSizeCategory(),
      this.getSlotsCount(),
      this.getCreatorId(),
      this.getCreatedAt(),
      this.getUpdatedAt(),
      this.getIsMultipage(),
      this.getIsAdjustable(),
      this.getSuitablePhotosCount(),
      this.getLabels(),
      this.getMinimalRequiredVersionIos(),
      this.getMinimalRequiredVersionAndroid(),
      this.getTemplateTagIds(),
      this.getShouldRemoveAnimatedThumbnail(),
      this.getThumbnailBinary(),
      this.getAnimatedThumbnailBinary(),
      this.getNewTemplateTagNames(),
      this.getSuitsVideo(),
      this.pagesInfo,
      this.templatePageIds,
    );
  }

  public isSingleTemplateModel(): this is SingleTemplateModel {
    return false;
  }

  public isMultiTemplateModel(): this is MultiTemplateModel {
    return true;
  }
}
